import { signal } from '@angular/core';
import { TempsWindsAloftLegendComponent } from './plugins/winds-aloft/temps-winds-aloft-legend/temps-winds-aloft-legend.component';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';

export const TEMPS_WINDS_ALOFT_LEGEND: TwcLegendParams = {
  title: 'WINDS / TEMPS ALOFT',
  legendTitleBarInfo: signal('0'),
  legendComponent: TempsWindsAloftLegendComponent
};
